import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../modules/layout/components/ToastContext';
import { useNavigate } from 'react-router-dom';
import { update } from '../_request';

interface VerifyUserEmailProps {
    targetProfileId: string;
    emailVerified?: boolean;
    onSuccess: () => void;
}

export default function VerifyUserEmail({ targetProfileId, emailVerified, onSuccess }: VerifyUserEmailProps) {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const handleVerify = async () => {
        try {
            setLoading(true);
            const result: any = await update(`/api/UserEvents/verifyuseremail?targetProfileId=${encodeURIComponent(targetProfileId)}`, null);
            const respStatus = result?.status ?? result?.response?.status;

            if (respStatus === 200 || respStatus === 204 || respStatus === undefined) {
                showToast && showToast(t('EmailVerifiedSuccessfully'), 'success');
                onSuccess();
            } else if (respStatus === 401) {
                navigate('/auth/login');
            } else if (respStatus === 403) {
                navigate('/error/403');
            } else if (respStatus === 404) {
                showToast && showToast(t('ProfileNotFound'), 'error');
            } else if (respStatus === 500) {
                navigate('/error/500');
            } else {
                showToast && showToast(t('StatusCode', { code: String(respStatus) }), 'error');
            }
        } catch (err: any) {
            console.error(err);
            showToast && showToast(t('ConnectionError', { error: String(err) }), 'error');
        } finally {
            setLoading(false);
            setOpen(false);
        }
    };

    return (
        <>
            <button 
    className="btn gg-btn gg-btn-profile--primary me-2" 
    onClick={() => setOpen(true)}
    disabled={emailVerified}
>
                {t('VerifyEmail')}
            </button>

            {open && (
                <div className="gg-modal-overlay">
                    <div className="gg-modal">
                        <div className="gg-modal-header">
                            <h5 className="mb-0">
                                {t('VerifyEmail')}
                            </h5>
                        </div>

                        <div className="gg-modal-body">
                            <p className="text-muted small mb-0">
                                {t('VerifyEmailConfirmation')}
                            </p>
                        </div>

                        <div className="gg-modal-footer">
                            <button
                                className="gg-btn"
                                onClick={() => setOpen(false)}
                                disabled={loading}
                            >
                                {t('Cancel')}
                            </button>

                            <button
                                className="btn btn-secondary text-white"
                                onClick={handleVerify}
                                disabled={loading}
                            >
                                {loading ? t('Verifying') : t('Confirm')}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}